/**
 * @deprecated Use translation json file instead
 */
export const COMMONS = {
  document: 'Documento',
  documentPlaceholder: 'Ingrese su documento de identidad...',
  fullName: 'Nombre completo',
  firstName: 'Nombres',
  middleName: 'Nombres',
  firstLastname: 'Apellidos',
  secondLastname: 'Apellidos',
  firstNamePlaceholder: 'Nombres...',
  secondNamePlaceholder: 'Nombres...',
  firstLastNamePlaceholder: 'Apellidos...',
  secondLastNamePlaceholder: 'Apellidos...',
  dateBorn: 'Fecha de nacimiento',
  code: 'Código',
  name: 'Nombre',
  update: 'Actualización',
  user: 'Usuario',
  userPlaceholder: 'Nombre de usuario para ingresar al sitio',
  date: 'Fecha',
  longDescription: 'Descripción',
  shortDescription: 'Descripción corta',
  parent: 'Padre',
  pickOnPlaceholder: 'Seleccione uno ...',
  status: 'Estado',
  enabled: 'Activado',
  disabled: 'Desactivado',
  saveSuccess: 'La información se guardó exitosamente!',
  emptyTable: 'No se encontraron registros',
  paginationText: 'elementos de',
  comments: 'Comentarios',
  actual: 'Consulta Actual',
  filters: 'Filtros',
  specialty: 'Especialidad',
  doctor: 'Médico',

  dateFormat: 'dd-mm-yy',
  dateFormatFull: 'dd-MM-yyyy',
  dateFormatLong: 'dd \'de\' MMMM \'de\' yyyy',
  datePlaceholder: 'dd-mm-aaaa'
};
